import { Dialog, Transition } from "@headlessui/react";
import { Fragment, ReactNode } from "react";
import { classNames } from "../utils";

interface IProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  width?: string;
  height?: string;
  icon?: ReactNode;
  titleSize?: "text-lg" | "text-xl" | "text-2xl";
  hideCloseButton?: boolean;
}

export const Modal = ({
  open,
  onClose,
  title,
  children,
  width,
  height,
  icon,
  titleSize = "text-lg",
  hideCloseButton = false,
}: IProps) => {
  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog
        as="div"
        className={classNames("relative z-50", height ?? "")}
        onClose={onClose}
      >
        <div className="fixed inset-0 overflow-y-auto bg-slate-500/90">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={`${
                  width ?? "w-full max-w-lg"
                } transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all`}
              >
                {!!title && (
                  <div className="flex justify-between items-center rounded-t dark:border-gray-600">
                    <div className="flex items-center">
                      {icon && <div className="mr-3">{icon}</div>}
                      <Dialog.Title
                        as="h3"
                        className={`${titleSize} font-semibold leading-6 text-gray-900`}
                      >
                        {title ?? ""}
                      </Dialog.Title>
                    </div>
                    {!hideCloseButton && (
                      <button
                        onClick={onClose}
                        className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                      >
                        <svg
                          className="w-5 h-5"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>
                    )}
                  </div>
                )}
                <div>{children}</div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};
